var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.621291 0.754975C0.557536 0.940071 0.522949 1.15649 0.522949 1.40126V18.5983C0.522949 18.8436 0.557582 19.0601 0.621416 19.2452L9.8658 9.99949L0.621291 0.754975ZM1.32218 19.9586C1.65123 20.0529 2.05873 19.9885 2.49878 19.739L13.4068 13.5405L10.5729 10.7066L1.32218 19.9586ZM14.3091 13.0286L17.6624 11.1234C18.7487 10.5052 18.7487 9.49512 17.6624 8.87772L14.3076 6.9714L11.28 9.99944L14.3091 13.0286ZM13.4058 6.45899L2.49878 0.261327C2.05867 0.0112285 1.65112 -0.0530047 1.32205 0.0415225L10.5729 9.29233L13.4058 6.45899Z",
    fill: "#7525D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.471aadf4c91affacc29baddbf28fd278.svg";
export { ForwardRef as ReactComponent };